import React from "react";
import PropTypes from 'prop-types'

function Style({ renderer }) {
    return (<>{renderer}</>)
}

Style.propTypes = {
    renderer: PropTypes.object.isRequired
}

export default Style;
